module.exports = __webpack_public_path__ + "img/sand-decal-15.ffe96393.png";